/** Set in `.storybook/preview.tsx` — skips PostHog feature-flag fetches. */
export function isPaladinStorybook(): boolean {
  return (
    (globalThis as { __PALADIN_STORYBOOK__?: boolean })
      .__PALADIN_STORYBOOK__ === true
  );
}

export function setPaladinStorybook(enabled: boolean): void {
  (globalThis as { __PALADIN_STORYBOOK__?: boolean }).__PALADIN_STORYBOOK__ =
    enabled;
}
